import api from "@/services/api";

export default {
  fetchExhibits() {
    return api.get(`exhibits/`)
  },
  deleteExhibit(exhibit) {
    return api.delete(`exhibits/${exhibit.pk}`)
  },
  editExhibitName(exhibit, name) {
    return api.patch(`exhibits/${exhibit.pk}/`, {name: name})
  },
  getSurveyExhibits(survey) {
    return api.post(`exhibits/get_exhibit_files/`, {survey: survey.pk})
  }
}